@let userAmountForm = amountFormGroup?.controls?.userAmount;
@if ((userAmountForm?.dirty || userAmountForm?.touched) && !userAmountForm?.hasError('expiredKycLimitValidation')) {
    @if (userAmountForm?.hasError('selfSetLimit')) {
        <div class="clear-both">
            @if (ccDepositLimitCheckEnabled && showCCDepositLimitCheckMsg) {
                <show-message id="creditcard_deposit_limit_message2" [type]="messageType.ERROR">
                    <div error>
                        <p>
                            {{
                                'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limit.message2'
                                    | translate
                                        : {
                                              annualLimit: 100 | vnCurrency: currencyUSD,
                                              avlAmount: +ccCurrentDepositLimit | vnCurrency: currencyUSD,
                                          }
                            }}
                        </p>
                        <p>
                            <a (click)="updateCcdLimit()" id="updateccdlimit" class="fr text-bold">
                                {{ 'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limits.update' | translate }}
                            </a>
                        </p>
                    </div>
                </show-message>
            }
            @if (maxDepositLimit > '0' && !showPrepaidCardsExceedsMessage) {
                <show-message id="creditcard_deposit_max_limit_1" [type]="messageType.ERROR">
                    <div error>
                        @if (maxDepositLimit > '0') {
                            @if (selfLimits?.type?.includes('purchase_limit')) {
                                <p
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.limits.purchaselimits.exceeded1.msg1'
                                            | translate: { frequency: limitPeriod, instrument: instrumentName }
                                    "></p>
                            } @else if (selfLimits?.type?.includes('svoc_limit')) {
                                <span>
                                    <p>
                                        {{
                                            'PARTY.CASHIER.web.limits.svoc.exceeded2'
                                                | translate
                                                    : {
                                                          remainingLimit:
                                                              maxDepositLimit
                                                              | vnCurrency: selectedOption()?.paymentMethodInfo?.maxDepositLimit?.currencyCode,
                                                      }
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'PARTY.CASHIER.web.deposit.limits.svoc.to_be_exceeded'
                                                | translate: { frequency: limitPeriod.toLowerCase() }
                                        }}
                                    </p>
                                    <a class="fr text-bold" (click)="changeAmount(maxDepositLimit)" id="updateAmount">{{
                                        'PARTY.CASHIER.web.limits.exceeded3' | translate
                                    }}</a>
                                </span>
                            } @else {
                                <p>{{ 'PARTY.CASHIER.web.limits.exceeded1.' + limitPeriod?.toLowerCase() | translate }}</p>
                            }
                            @if (minDepositLimitCheck && !selfLimits?.type?.includes('svoc_limit')) {
                                <p>
                                    {{
                                        'PARTY.CASHIER.web.limits.exceeded2'
                                            | translate
                                                : {
                                                      remainingLimit:
                                                          maxDepositLimit
                                                          | vnCurrency: selectedOption()?.paymentMethodInfo?.maxDepositLimit?.currencyCode,
                                                  }
                                    }}
                                </p>
                            }

                            @if (minDepositLimitCheck && !selfLimits?.type?.includes('svoc_limit')) {
                                <a class="fr text-bold" (click)="changeAmount(maxDepositLimit)" id="updateAmount">{{
                                    'PARTY.CASHIER.web.limits.exceeded3' | translate
                                }}</a>
                            }
                        }
                    </div>
                </show-message>
            }
            @if (maxDepositLimit == '0') {
                <show-message id="creditcard_deposit_max_limit" [type]="messageType.ERROR">
                    <div error>
                        @if (selfLimits.type.includes('rg_limit')) {
                            <p>
                                <span>{{ 'PARTY.CASHIER.web.limits.rg.exceeded.' + limitPeriod?.toLowerCase() | translate }}</span>
                                @if (country == 'BE') {
                                    <span
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.limits.rg.review'
                                                | translate
                                                    : {
                                                          increaseLimitUrl: depositInfo.increaseLimitUrl,
                                                      }
                                        ">
                                    </span>
                                } @else {
                                    <span>{{ 'PARTY.CASHIER.web.limits.rg.non_be.review' | translate }}</span>
                                }
                            </p>
                        }
                        @if (
                            selfLimits.type.includes('purchase_limit') ||
                            selfLimits.type.includes('overall_deposit_limit') ||
                            selfLimits.type.includes('svoc_limit')
                        ) {
                            @if (selfLimits.type.includes('purchase_limit')) {
                                <p
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.limits.purchaselimits.exceeded1.msg2'
                                            | translate: { frequency: limitPeriod, instrument: instrumentName }
                                    "></p>
                            } @else if (selfLimits.type.includes('svoc_limit')) {
                                <p>
                                    <b
                                        ><span class="font-bold">
                                            {{
                                                'PARTY.CASHIER.web.deposit.limits.svoc.exceeded1' | translate: { limit: svocLimit | vnCurrency }
                                            }}</span
                                        ></b
                                    >
                                </p>
                                <p>
                                    <span> {{ 'PARTY.CASHIER.web.deposit.limits.svoc.exceeded2' | translate }}</span>
                                </p>
                                <a
                                    (click)="findOutMoreClick()"
                                    href="{{ findoutMoreLink }}"
                                    target="_top"
                                    class="d-inline-block float-right font-weight-bold mt-1 cursor-pointer"
                                    >{{ 'PARTY.CASHIER.web.deposit.limits.svoc.exceeded.findoutmore' | translate }}</a
                                >
                            } @else {
                                <span>{{ 'PARTY.CASHIER.web.limits.purchaselimits.exceeded' | translate }} </span>
                                <span
                                    class="transaction-link"
                                    style="cursor: pointer; text-decoration: underline"
                                    (click)="gotoTransactionHistory()"
                                    id="gotoTransactionHistory"
                                    [vnDynamicHtml]="'PARTY.CASHIER.web.limits.purchaselimits.paymenthistory' | translate"></span>
                            }
                        }
                    </div>
                </show-message>
            }
        </div>
    } @else if (userAmountForm?.hasError('spainRekycLimit') && spainRekycLimitTemplate) {
        <show-message [type]="messageType.WARNING">
            <div warning>
                <p class="text-bold">
                    {{
                        'PARTY.CASHIER.web.deposit.rekyc.tobeExceeded.limit.' + spainRekycLimitTemplate + '.minAmount.header'
                            | translate
                                : {
                                      remainingLimit:
                                          userDataService?.userData?.configParams?.rekycRemainingLimit
                                          | vnCurrency: selectedOption()?.paymentMethodInfo?.maxDepositLimit?.currencyCode : '1.0',
                                  }
                    }}
                </p>
                <p>{{ 'PARTY.CASHIER.web.deposit.rekyc.tobeExceeded.limit.' + spainRekycLimitTemplate + '.minAmount.text' | translate }}</p>
                <div class="fr mt-2">
                    @if (spainRekycLimitTemplate == 'available') {
                        <a
                            class="text-bold text-decoration-none mr-3 text-uppercase"
                            (click)="changeAmount(userDataService?.userData?.configParams?.rekycRemainingLimit)"
                            >{{ 'PARTY.CASHIER.web.deposit.rekyc.updateAmount' | translate }}</a
                        >
                    }
                    <a
                        (click)="uploadMyId()"
                        class="text-bold text-decoration-none text-uppercase"
                        href="{{ userDataService?.userData?.configParams?.rekycUrl }}"
                        target="_top"
                        >{{ 'PARTY.CASHIER.web.deposit.rekyc.exhausted.limit.uploadMyId.link' | translate }}</a
                    >
                </div>
            </div>
        </show-message>
    } @else if (userAmountForm?.hasError('spainOdInlineVal')) {
        <show-message [type]="messageType.WARNING">
            <div warning>
                <span>
                    <strong
                        [vnDynamicHtml]="
                            'PARTY.CASHIER.web.deposit.occu.msg2'
                                | translate
                                    : {
                                          amount: behaviorData?.userODetails?.allowedAmt | vnCurrency: currencyEUR,
                                      }
                        "></strong>
                    <p>{{ 'PARTY.CASHIER.web.deposit.occu.msg3' | translate }}</p>
                    <div class="mt-2 fr text-bold customfont">
                        <a class="text-decoration-none mr-2" (click)="updateAmount('occupDet')" id="updateAmount">{{
                            'PARTY.CASHIER.web.deposit.occu.button3' | translate
                        }}</a>
                        <a class="text-decoration-none" target="_top" (click)="shareOD()" href="{{ behaviorData?.userODetails?.urlInfo?.url }}">{{
                            'PARTY.CASHIER.web.deposit.occu.button4' | translate
                        }}</a>
                    </div>
                </span>
            </div>
        </show-message>
    }
}
@if (
    (userAmountForm?.dirty || userAmountForm?.touched) &&
    userAmountForm?.hasError('spainAnnRekycLimitExceeded') &&
    spainRekycLimitTemplate === 'available'
) {
    <show-message [type]="messageType.WARNING">
        <div warning>
            <p class="text-bold">
                {{
                    'PARTY.CASHIER.web.deposit.annual.rekyc.error.inline.header'
                        | translate
                            : {
                                  allowedLimit: userDataService?.userData?.configParams?.rekycRemainingLimit | vnCurrency,
                              }
                }}
            </p>
            <p>{{ 'PARTY.CASHIER.web.deposit.annual.rekyc.error.inline.text' | translate }}</p>
            <div class="fr mt-2">
                <a class="text-bold text-decoration-none mr-3 text-uppercase" (click)="updateAmount('annRekyc')">{{
                    'PARTY.CASHIER.web.deposit.rekyc.updateAmount' | translate
                }}</a>
                <a
                    class="text-bold text-decoration-none text-uppercase"
                    href="{{ userDataService?.userData?.configParams?.rekycUrl + '&cashierQd=true' }}"
                    target="_top"
                    (click)="uploadMyIdAnn(true)"
                    >{{ 'PARTY.CASHIER.web.deposit.annual.rekyc.error.uploadMyId.text' | translate }}</a
                >
            </div>
        </div>
    </show-message>
}
@if (
    (userAmountForm?.dirty || userAmountForm?.touched) &&
    userAmountForm?.hasError('spainAnnRekycLimitExceeded') &&
    spainRekycLimitTemplate === 'unAvailable'
) {
    <show-message [type]="messageType.ERROR">
        <div error>
            <p class="text-bold">
                {{ 'PARTY.CASHIER.web.deposit.annual.rekyc.error.upload.your.id.header' | translate }}
            </p>
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.annual.rekyc.error.allowed.lessthan.minlim.text'
                        | translate
                            : {
                                  allowedLimit: userDataService?.userData?.configParams?.rekycRemainingLimit | vnCurrency,
                                  rekycLimit: userDataService?.userData?.configParams?.rekycLimit | vnCurrency,
                                  minLimit: selectedOption()?.paymentMethodInfo?.minDepositLimit?.value | vnCurrency,
                              }
                }}
            </p>
            <div class="fr mt-2">
                <a
                    class="text-bold text-decoration-none text-uppercase"
                    href="{{ userDataService?.userData?.configParams?.rekycUrl + '&cashierQd=true' }}"
                    target="_top"
                    (click)="uploadMyIdAnn(false)"
                    >{{ 'PARTY.CASHIER.web.deposit.annual.rekyc.error.uploadMyId.text' | translate }}</a
                >
            </div>
        </div>
    </show-message>
}
@if (
    (amountFormGroup?.controls?.userAmount?.dirty || amountFormGroup?.controls?.userAmount?.touched) &&
    amountFormGroup?.controls?.userAmount?.hasError('spainThreshLimitToBeBreached') &&
    !userAmountForm?.hasError('expiredKycLimitValidation')
) {
    <show-message [type]="messageType.ERROR">
        <div error>
            <span class="text-bold">
                {{ 'PARTY.CASHIER.web.deposit.aml.header1' | translate }}
            </span>
            <p
                class="mt-2"
                [innerHTML]="
                    'PARTY.CASHIER.web.deposit.aml.msg2'
                        | translate
                            : {
                                  amount: es_threshold_limit | vnCurrency,
                                  paymentName: selectedOption()?.paymentMethodInfo?.paymentMethod?.toUpperCase(),
                              }
                "></p>
            <div class="d-inline-block float-right mt-3">
                <a class="text-bold cursor-pointer text-decoration-none text-uppercase" (click)="updateAmount('amlThresh')">
                    {{ 'PARTY.CASHIER.web.deposit.occu.button3' | translate }}
                </a>
                <a
                    class="text-bold cursor-pointer ml-1 text-decoration-none text-uppercase"
                    (click)="verifyAccount(selectedOption(), 'under 2k banner')">
                    {{ 'PARTY.CASHIER.web.deposit.aml.verify.txt' | translate }}
                </a>
            </div>
        </div>
    </show-message>
} @else if (
    (amountFormGroup?.controls?.userAmount?.dirty || amountFormGroup?.controls?.userAmount?.touched) &&
    amountFormGroup?.controls?.userAmount?.hasError('spainThreshLimitBreached') &&
    !userAmountForm?.hasError('expiredKycLimitValidation')
) {
    <show-message [type]="messageType.ERROR">
        <div error>
            <span class="text-bold">
                {{ 'PARTY.CASHIER.web.deposit.aml.header1' | translate }}
            </span>
            <p
                class="mt-2"
                [innerHTML]="
                    'PARTY.CASHIER.web.deposit.aml.msg3'
                        | translate
                            : {
                                  paymentName: selectedOption()?.paymentMethodInfo?.paymentMethod?.toUpperCase(),
                              }
                "></p>
            <div class="d-inline-block float-right mt-2">
                <a
                    class="text-bold cursor-pointer ml-1 text-decoration-none text-uppercase"
                    (click)="verifyAccount(selectedOption(), 'over 2k banner')">
                    {{ 'PARTY.CASHIER.web.deposit.aml.verify.txt' | translate }}
                </a>
            </div>
        </div>
    </show-message>
}
@if (enablePrepaidcardRestrictions && showPrepaidCardsExceedsMessage && !userAmountForm?.hasError('expiredKycLimitValidation')) {
    <show-message id="enable_prepaidcard_restrictions" [type]="messageType.ERROR">
        <div error>
            @let currencyCode = selectedOption()?.paymentMethodInfo?.minDepositLimit?.currencyCode;
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.prepaidCard.deposits.entered.exceeds.cumulativeAmount'
                        | translate
                            : {
                                  maxLimit: rollingWeekMaxAmount | vnCurrency: currencyCode,
                                  remainingAmount: rollingWeekRemainingAmount | vnCurrency: currencyCode,
                              }
                }}
            </p>
            <a class="fr text-bold" (click)="changeAmount(rollingWeekRemainingAmount)">
                {{ 'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limits.update' | translate }}
            </a>
        </div>
    </show-message>
}
@if ((userAmountForm?.dirty || userAmountForm?.touched) && userAmountForm?.hasError('expiredKycLimitValidation') && spainRekycLimitTemplate) {
    @if (spainRekycLimitTemplate == 'unAvailable') {
        <show-message [type]="messageType.ERROR">
            <div error>
                <p class="text-bold">{{ 'PARTY.CASHIER.web.deposit.expiredId.uploadYourId.cta' | translate }}</p>
                <p
                    [innerHtml]="
                        'PARTY.CASHIER.web.deposit.expiredId.within.gracePeriod.exceeded.minLimit'
                            | translate
                                : {
                                      remainingAmount:
                                          userDataService.userData?.configParams?.rekycRemainingLimit
                                          | vnCurrency: selectedOption().paymentMethodInfo?.maxDepositLimit?.currencyCode : '1.0',
                                      reKycLimit:
                                          userDataService.userData?.configParams?.rekycLimit
                                          | vnCurrency: selectedOption().paymentMethodInfo?.maxDepositLimit?.currencyCode : '1.0',
                                      minLimit:
                                          selectedOption().paymentMethodInfo?.minDepositLimit?.value
                                          | vnCurrency: selectedOption().paymentMethodInfo?.maxDepositLimit?.currencyCode : '1.0',
                                  }
                    "></p>
                <div class="d-inline-block float-right mt-3">
                    <a
                        class="text-bold cursor-pointer text-decoration-none text-uppercase"
                        href="{{ userDataService.userData?.configParams?.rekycUrl + '&cashierQd=true' }}"
                        target="_top"
                        (click)="uploadMyIdAnn(false)">
                        {{ 'PARTY.CASHIER.web.deposit.expiredId.uploadMyId.cta' | translate }}
                    </a>
                </div>
            </div>
        </show-message>
    } @else {
        <show-message [type]="messageType.WARNING">
            <div warning>
                <p class="text-bold">
                    {{
                        'PARTY.CASHIER.web.deposit.expiredId.within.gracePeriod.text4'
                            | translate
                                : {
                                      remainingAmount:
                                          userDataService.userData?.configParams?.rekycRemainingLimit
                                          | vnCurrency: selectedOption().paymentMethodInfo?.maxDepositLimit?.currencyCode : '1.0',
                                  }
                    }}
                </p>
                <p>{{ 'PARTY.CASHIER.web.deposit.expiredId.within.gracePeriod.text5' | translate }}</p>
                <div class="d-inline-block float-right mt-3">
                    <a
                        class="text-bold cursor-pointer text-decoration-none text-uppercase mr-2"
                        (click)="changeAmount(userDataService.userData?.configParams?.rekycRemainingLimit)">
                        {{ 'PARTY.CASHIER.web.deposit.expiredId.updateAmount.cta' | translate }}
                    </a>
                    <a
                        class="text-bold cursor-pointer text-decoration-none text-uppercase"
                        href="{{ userDataService.userData?.configParams?.rekycUrl + '&cashierQd=true' }}"
                        target="_top"
                        (click)="uploadMyIdAnn(true)">
                        {{ 'PARTY.CASHIER.web.deposit.expiredId.uploadMyId.cta' | translate }}
                    </a>
                </div>
            </div>
        </show-message>
    }
}
